import { render, staticRenderFns } from "./complaint-item.vue?vue&type=template&id=fa6d4568&scoped=true"
import script from "./complaint-item.vue?vue&type=script&lang=js"
export * from "./complaint-item.vue?vue&type=script&lang=js"
import style0 from "./complaint-item.vue?vue&type=style&index=0&id=fa6d4568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d4568",
  null
  
)

export default component.exports